<!-- MODAL devolverDoc -->
<div mdbModal #devolverDoc="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Devolver documento
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="devolverDoc.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]='formHeader' novalidate>
                    <div class="row">
                        <div class="col dato">
                            <div class="md-form">
                                <mdb-select label="Seleccionar Motivo" [options]="optionsMotivo" required
                                    placeholder="Seleccionar motivo" [filterEnabled]="true" formControlName="motivo">
                                </mdb-select>
                                <div *ngIf="
                                formHeader.get('motivo').invalid &&
                                (formHeader.get('motivo').dirty ||
                                formHeader.get('motivo').touched)
                                ">
                                    <mdb-error *ngIf="formHeader.get('motivo').hasError('required')">
                                        Ingrese motivo
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button size="sm" type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                    (click)="devolverDoc.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <!-- <button type="button" class="btn btn-success waves-light" mdbWavesEffect (click)="devolverDocumento()">
                    Confirmar
                </button> -->
                <app-api-button [processing]="processing" (click2)="devolverDocumento()">
                    Confirmar
                </app-api-button>
            </div>
        </div>
    </div>
</div>